import { useContext } from 'react';
import { viewerDataContext, ViewerDataContext } from './ViewerContext';

const useViewerDataContext = (): ViewerDataContext => {
  const viewerTools = useContext<ViewerDataContext>(viewerDataContext);

  return viewerTools;
};

export default useViewerDataContext;
